import { render, staticRenderFns } from "./single-lightbox.vue?vue&type=template&id=0af90146"
import script from "./single-lightbox.vue?vue&type=script&lang=js"
export * from "./single-lightbox.vue?vue&type=script&lang=js"
import style0 from "./single-lightbox.vue?vue&type=style&index=0&id=0af90146&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af90146')) {
      api.createRecord('0af90146', component.options)
    } else {
      api.reload('0af90146', component.options)
    }
    module.hot.accept("./single-lightbox.vue?vue&type=template&id=0af90146", function () {
      api.rerender('0af90146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/image/single-lightbox.vue"
export default component.exports